<template>
  <div
    class="bg-white mb-[24px]"
  >
    <!-- Header -->
    <div class="flex flex-col md:flex-row md:items-center justify-between gap-[16px] md:gap-[8px] mb-[24px] px-[20px] py-[16px] border-b-[1px] border-b-[#E5E5E5]">
      <div class="flex items-center gap-[8px] shrink-0">
        <Button
          outline
          type="icon"
          @click="$router.go(-1)"
        >
          <span class="k-arrow-left-2 text-[#0A0A0A]" />
        </Button>
        <span class="text-[#0A0A0A] font-semibold">
          Detail Fulfillment
        </span>
      </div>
    </div>

    <div
      v-if="loading"
      class="mx-[20px] flex items-center justify-center gap-[10px]"
    >
      <b-spinner
        v-if="loading"
        variant="primary"
      />
      <p class="mb-0">
        Memuat data...
      </p>
    </div>
    <div
      v-else-if="isError"
      class="mx-[20px] flex items-center justify-center gap-[10px]"
    >
      <p class="mb-0">
        Gagal mengambil data, silahkan coba lagi.
      </p>
    </div>
    <div
      v-else
    >
      <div class="border rounded-[12px] mx-[24px] p-[16px] mb-[24px]">
        <div class="grid sm:grid-cols-3 gap-[24px] text-[14px] text-[#0A0A0A] [&>div]:flex [&>div]:items-start [&>div]:justify-start [&>div]:flex-col [&>div]:gap-[4px]">
          <div>
            <div class="font-medium mb-[4px]">
              Mitra Gudang
            </div>
            <div>
              {{ data.warehouse_name || '-' }}
            </div>
            <div class="capitalize text-[#737373] text-[12px]">
              {{ data.warehouse_location || '-' }}
            </div>
          </div>
          <div>
            <div class="font-medium mb-[4px]">
              Outbond ID
            </div>
            <div>
              {{ data.id || '-' }}
            </div>
            <div
              :class="{
                'text-[12px]': true,
                'text-[#4285F4]': isPrinted,
                'text-[#F95031]': !isPrinted,
              }"
            >
              {{ awbPrintedAtLabel }}
            </div>
          </div>
          <div>
            <div class="font-medium mb-[4px]">
              Status
            </div>
            <div>
              <StatusOrderPill
                :status="data.status"
                :mapping="statusMapping"
              />
            </div>
          </div>
          <div>
            <div class="font-medium mb-[4px]">
              Label Pengiriman
            </div>
            <div>
              <a
                v-if="data.label_url"
                :href="data.label_url"
                target="_blank"
                class="text-[#0A0A0A] hover:underline"
              >
                {{ data.label_name || '-' }}
              </a>
              <span
                v-else
                class="text-[#0A0A0A]"
              >
                {{ data.label_name || '-' }}
              </span>
            </div>
          </div>
          <div>
            <div class="font-medium mb-[4px]">
              Jumlah Order
            </div>
            <div>
              {{ grandTotalOrder }}
            </div>
          </div>
          <div>
            <div class="font-medium mb-[4px]">
              Jumlah Produk
            </div>
            <div>
              {{ totalProduct }}
            </div>
          </div>
        </div>
      </div>

      <div class="mx-[24px]">
        <Table
          :columns="fulfillmentNonKomshipDetailFields"
          :items="orderSummary"
          :loading="loading"
          empty-text="Tidak ada data yang ditampilkan."
          max-height="50vh"
          sticky-header
        >
          <template #cell(no)="{ index }">
            <span class="text-[#0A0A0A] font-normal">{{ index + 1 }}</span>
          </template>

          <template #cell(awb)="{ item }">
            <span class="text-[#0A0A0A] font-normal">{{ item.awb || '-' }}</span>
          </template>

          <template #cell(products)="{ item, index }">
            <div
              v-for="(product, pIdx) in item.products"
              :key="`${product.product_variant_id}-${product.product_id}-${pIdx}`"
              :class="{
                'mb-[10px] border-b border-[#E0E0E0] pb-[10px] border-dashed': true,
                'border-b-0 border-none pb-0 mb-0': pIdx === item.products.length - 1,
              }"
            >
              <div class="flex items-center justify-between gap-[8px] text-black">
                <span class="font-medium">
                  {{ product.product_name || '-' }}
                </span>
              </div>
              <p
                v-if="product.product_variant_name"
                class="mb-0 text-[#666666]"
              >
                {{ product.product_variant_name }}
              </p>
              <div
                v-else-if="product.is_bundling"
                class="relative"
              >
                <!-- Hidden checkbox untuk kontrol toggle -->
                <input
                  :id="`bundling-toggle-${index}-${item.outbound_detail_id}-${product.product_id}-${pIdx}`"
                  type="checkbox"
                  class="hidden peer"
                  :aria-label="`Toggle bundling details for ${product.product_name}`"
                >

                <!-- Button bundling sebagai label -->
                <label
                  :for="`bundling-toggle-${index}-${item.outbound_detail_id}-${product.product_id}-${pIdx}`"
                  class="flex items-center gap-[4px] py-[4px] px-[8px] rounded-[12px] !bg-[#08A0F7] text-white font-[500] cursor-pointer mt-[5px] w-[7rem] transition-all duration-200 hover:bg-[#0691d6] peer-checked:bg-[#0691d6]"
                >
                  <img
                    src="https://storage.googleapis.com/komerce/assets/komerce-icon/Putih/gift.svg"
                    alt="bundling"
                    width="16"
                  >
                  <span>Bundling</span>
                </label>

                <!-- List bundling yang akan muncul/hilang -->
                <div class="hidden peer-checked:block peer-checked:visible mt-[8px] animate-[fadeIn_0.2s_ease-in-out]">
                  <div class="bg-gray-50 rounded-[8px] p-[8px] border-l-4 border-[#08A0F7]">
                    <h4 class="text-sm font-semibold text-gray-700">
                      Isi Bundling:
                    </h4>
                    <div class="bg-white rounded-[8px] overflow-hidden shadow-sm">
                      <b-table
                        :items="product.product_bundles || []"
                        :fields="fieldsDetailBundling"
                        class="!rounded-[8px] mb-0"
                        small
                      >
                        <template #cell(product_name)="bundleData">
                          <div>
                            <p class="mb-0 font-semibold text-sm">
                              {{ bundleData.value }}
                            </p>
                            <p
                              v-if="bundleData.item && bundleData.item.product_variant_name"
                              class="mb-0 text-xs text-gray-500"
                            >
                              {{ bundleData.item.product_variant_name }}
                            </p>
                            <p
                              v-else
                              class="mb-0 text-xs text-gray-400"
                            >
                              -
                            </p>
                          </div>
                        </template>
                        <template #cell(qty)="bundleData">
                          <span class="text-sm font-semibold text-[#08A0F7]">
                            {{ bundleData.value || 1 }} X
                          </span>
                        </template>
                      </b-table>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-else
                class="text-[#666666]"
              >
                -
              </div>
            </div>
          </template>

          <template #cell(total_item)="{ item }">
            <span class="text-[#0A0A0A] font-normal">{{ calculateItemTotal(item) }}</span>
          </template>

          <template #cell(packings)="{ item }">
            <div
              v-if="item.packings && item.packings.length > 0"
              class="flex flex-col gap-1"
            >
              <div
                v-for="(packing, pIdx) in item.packings"
                :key="pIdx"
                class="flex items-center justify-between gap-4 max-w-[160px]"
              >
                <span class="text-[#0A0A0A]">{{ packing.name || '-' }}</span>
                <span class="text-[#0A0A0A] font-medium">x{{ packing.layer || '-' }}</span>
              </div>
            </div>
            <span
              v-else
              class="text-[#737373]"
            >-</span>
          </template>

          <template #cell(status)="{ item }">
            <StatusOrderPill
              :status="item.status"
              :mapping="statusMapping"
            />
          </template>

          <template #cell(fulfillment_fee_per_order)="{ item }">
            <span class="text-[#0A0A0A] font-normal">
              {{ (item.fulfillment_fee_per_order !== undefined && item.fulfillment_fee_per_order !== null ? item.fulfillment_fee_per_order : item.fulfillment_fee) | rupiah }}
            </span>
          </template>
        </Table>

        <div class="py-[48px] text-right text-[#0A0A0A] text-[14px]">
          <span>
            Total Biaya Fulfillment:
          </span>
          <span class="mb-0">
            {{ (data.grand_fulfillment_fee || 0) | rupiah }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { Button, Table } from '@/@core/components/ui'
import StatusOrderPill from '../../components/StatusOrderPill.vue'
import {
  fieldsDetailBundling, fieldsDetailProduct, handleStatusClasses, statusMapping,
} from './config'

/**
 * Component untuk menampilkan detail fulfillment non-komship
 * @component FulfillmentNonKomshipDetail
 */
export default {
  components: {
    Button,
    Table,
    StatusOrderPill,
  },
  data() {
    return {
      loading: true,
      isError: false,
      data: {},
      statusMapping,
      fulfillmentNonKomshipDetailFields: fieldsDetailProduct,
      fieldsDetailBundling,
    }
  },
  computed: {
    isPrinted() {
      return Boolean(this.data.last_printed_at || this.data.printed_at)
    },
    awbPrintedAtLabel() {
      const printedTime = this.data.last_printed_at || this.data.printed_at
      if (printedTime) {
        return `Label telah diunduh pada ${moment(printedTime).format('HH.mm')}`
      }
      return 'Label belum diunduh'
    },
    processedStatus() {
      const status = this.handleStatus(this.data.status)
      return {
        text: status,
        classes: this.handleStatusClasses(status),
      }
    },
    orderSummary() {
      return Array.isArray(this.data.order_summary) ? this.data.order_summary : []
    },
    totalProduct() {
      return this.orderSummary.reduce((acc, item) => acc + (Array.isArray(item.products) ? item.products.reduce((sum, product) => sum + (Number(product.total_item) || 0), 0) : 0), 0)
    },
    totalOrder() {
      return this.orderSummary.reduce((acc, item) => {
        if (item.status === this.data.status) {
          return acc + 1
        }
        return acc
      }, 0)
    },
    grandTotalOrder() {
      return this.orderSummary.length
    },
  },
  mounted() {
    this.fnFetchData()
  },
  methods: {
    handleStatusClasses,
    calculateItemTotal(item) {
      if (Array.isArray(item?.products) && item.products.length > 0) {
        return item.products.reduce((acc, product) => acc + (Number(product.total_item) || 0), 0)
      }
      return item?.total_item || item?.total_order || 0
    },
    getPackingName(packing) {
      if (typeof packing === 'string') return packing
      return packing?.name || packing?.packing_name || packing?.packing_material || '-'
    },
    getPackingQty(packing) {
      if (typeof packing === 'string') return 1
      return packing?.layer || packing?.qty || packing?.quantity || packing?.total || packing?.count || 1
    },
    async fnFetchData() {
      const outboundId = this.$route?.params?.id
      if (!outboundId) {
        this.isError = true
        this.loading = false
        return
      }
      this.loading = true
      this.isError = false
      try {
        const { data } = await this.$http_new.get(`/kompack/api/v1/dashboard/admin/outbounds/${outboundId}/details`)
        const responseData = data?.data || {}
        const rawSummary = Array.isArray(responseData.order_summary) ? responseData.order_summary : []
        const mappedData = rawSummary.flatMap(item => {
          const count = Number(item.total_order) || 1
          if (count <= 1) return [item]
          return Array.from({ length: count }, () => ({ ...item }))
        })
        this.data = {
          ...responseData,
          order_summary: mappedData,
        }
      } catch (error) {
        this.isError = true
      } finally {
        this.loading = false
      }
    },
    /**
     * Handle status display berdasarkan status value
     * @param {string} status - Status fulfillment
     * @returns {string} Text status yang ditampilkan
     */
    handleStatus(status) {
      if (status === 'submitted') return 'Diajukan'
      if (status === 'confirmed') return 'Dipacking'
      if (status === 'canceled') return 'Dibatalkan'
      return status
    },
  },
}
</script>
